<mat-form-field appearance="outline" class="custom_text_input_field cutom_select_input_field">
    <mat-label>{{field.label}}</mat-label>
    <mat-select [(value)]="dataArray" panelClass="custom_select_box" multiple #check>
        <ng-container *ngFor="let item of field.options" ;>
            <mat-option (click)="toggleSelection()" [value]="item.value">{{item.key}}</mat-option>
        </ng-container>
    </mat-select>
</mat-form-field>